import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { MedicineActiveIngredients, MedicinePackage } from '~libs.desktop.shared.medicine';

import { MedicineHeading } from '../MedicineHeading';

type ExtendedDosageMedicineHeaderProps = {
   readonly medicine: MedicineSimple;
   readonly reimbursements: PatientMedicine['reimbursements'];
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const ExtendedDosageMedicineHeader = (props: ExtendedDosageMedicineHeaderProps): JSX.Element => {
   return (
      <StyledFlex direction={'row'} justifyContent={'space-between'} alignItems={'flex-start'} gap={'16px'}>
         <StyledFlex direction={'column'} gap={'2px'}>
            <MedicineHeading
               medicine={props.medicine}
               reimbursements={props.reimbursements}
               visitDiagnoses={props.visitDiagnoses}
            />
            <MedicineActiveIngredients activeIngredients={props.medicine.activeIngredients} />
         </StyledFlex>
         <MedicinePackage
            form={props.medicine.form}
            dose={props.medicine.dose}
            packageContent={props.medicine.packageContent}
            valid={props.medicine.valid}
         />
      </StyledFlex>
   );
};
